import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import SiteFooter from 'src/components/SiteFooter';
import NavBar from './NavBar';
import TopBar, {
  HOME_TOP_BAR_HEIGHT_MOBILE_PX,
  HOME_TOP_BAR_HEIGHT_PX,
  homeTopBarHeightCss,
} from './TopBar';

const HORIZONTAL_LOGO_SRC = '/static/news/1000containers-horizontal-white.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  rootLight: {
    backgroundColor: '#f3f4f6',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: homeTopBarHeightCss(HOME_TOP_BAR_HEIGHT_MOBILE_PX),
    [theme.breakpoints.up('sm')]: {
      paddingTop: homeTopBarHeightCss(HOME_TOP_BAR_HEIGHT_PX),
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  },
  main: {
    flex: '1 1 auto'
  }
}));

function DashboardLayout({ children }) {
  const classes = useStyles();
  const location = useLocation();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const useLightShell = location.pathname === '/login';

  return (
    <div className={clsx(classes.root, useLightShell && classes.rootLight)}>
      <TopBar
        onMobileNavOpen={() => setMobileNavOpen(true)}
        logoSrc={HORIZONTAL_LOGO_SRC}
      />

      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <div className={classes.main}>
              {children}
            </div>
            <SiteFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
